"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var ChatService_1;
var _a, _b, _c, _d, _e, _f;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatServiceInstance = void 0;
const client_1 = require("@rws-framework/client");
const ChatEventsService_1 = __importStar(require("./chat/ChatEventsService"));
const ChatConfigService_1 = __importStar(require("./chat/ChatConfigService"));
const ChatStateService_1 = __importStar(require("./chat/ChatStateService"));
const ChatAudioService_1 = __importStar(require("./chat/ChatAudioService"));
const ChatInteractionService_1 = __importStar(require("./chat/ChatInteractionService"));
const StorageService_1 = __importStar(require("@front/services/StorageService"));
let ChatService = ChatService_1 = class ChatService extends client_1.RWSService {
    constructor(chatEventsService, chatConfigService, chatStateService, chatAudioService, chatInteractionService, storageService) {
        super();
        this.chatEventsService = chatEventsService;
        this.chatConfigService = chatConfigService;
        this.chatStateService = chatStateService;
        this.chatAudioService = chatAudioService;
        this.chatInteractionService = chatInteractionService;
        this.storageService = storageService;
    }
    /**
     * Initialize the chat service
     */
    initialize(chatComponent) {
        this.chatConfigService.initializeLanguage(this.storageService);
        this.chatInteractionService.initializeHeaders();
        console.log({
            selectedModel: chatComponent.selectedModel,
            overrides: this.chatConfigService.getOverridesData()
        });
        if (!this.chatConfigService.getOverridesData().selectedModel && chatComponent.selectedModel) {
            this.chatConfigService.updateOverrides({ selectedModel: chatComponent.selectedModel });
        }
    }
    /**
     * Get the events service
     */
    getEventsService() {
        return this.chatEventsService;
    }
    /**
     * Get the config service
     */
    getConfigService() {
        return this.chatConfigService;
    }
    /**
     * Get the state service
     */
    getStateService() {
        return this.chatStateService;
    }
    /**
     * Get the audio service
     */
    getAudioService() {
        return this.chatAudioService;
    }
    /**
     * Get the interaction service
     */
    getInteractionService() {
        return this.chatInteractionService;
    }
    /**
     * Handle web search enable/disable
     */
    handleWebSearchChange(enabled, chatElement) {
        if (ChatService_1.VERBOSE) {
            console.log('[ChatService] Handling web search change:', enabled);
        }
        this.chatStateService.webSearchEnabled = enabled;
        this.chatConfigService.updateOverrides({ webSearchEnabled: enabled });
        if (chatElement) {
            if (ChatService_1.VERBOSE) {
                console.log('[ChatService] Resetting chat element for web search change');
            }
            this.chatInteractionService.resetChat(chatElement, () => this.chatConfigService.getOverrides());
        }
        this.chatEventsService.handleWebSearchChange(enabled);
    }
    /**
     * Handle deep search enable/disable
     */
    handleDeepSearchChange(enabled, chatElement) {
        if (ChatService_1.VERBOSE) {
            console.log('[ChatService] Handling deep search change:', enabled);
        }
        this.chatStateService.deepSearchEnabled = enabled;
        this.chatConfigService.updateOverrides({ deepSearchEnabled: enabled });
        if (chatElement) {
            if (ChatService_1.VERBOSE) {
                console.log('[ChatService] Resetting chat element for deep search change');
            }
            this.chatInteractionService.resetChat(chatElement, () => this.chatConfigService.getOverrides());
        }
        this.chatEventsService.handleDeepSearchChange(enabled);
    }
    /**
     * Handle knowledge change
     */
    handleKnowledgeChange(knowledge, chatElement) {
        this.chatStateService.knowledge = knowledge;
        this.chatConfigService.updateOverrides({ knowledge });
        if (chatElement) {
            chatElement.requestUpdate();
        }
    }
    /**
     * Handle full knowledge IDs change (1:1 mode)
     */
    handleFullKnowledgeChange(fullKnowledgeIds, chatElement) {
        this.chatStateService.fullKnowledgeIds = fullKnowledgeIds;
        this.chatConfigService.updateOverrides({ fullKnowledgeIds });
        if (chatElement) {
            chatElement.requestUpdate();
        }
    }
    handleFullscanChange(fullscan, chatElement) {
        this.chatStateService.fullscan = fullscan;
        this.chatConfigService.updateOverrides({ fullscan });
        if (chatElement) {
            this.chatInteractionService.resetChat(chatElement, () => this.chatConfigService.getOverrides());
        }
    }
    /**
     * Handle AI provider change
     */
    handleAIProviderChange(provider) {
        this.chatStateService.selectedAIProvider = provider;
        this.chatConfigService.updateOverrides({ aiProvider: provider });
    }
    /**
     * Handle model change
     */
    handleModelChange(model) {
        this.chatStateService.selectedModel = model;
        this.chatStateService.selectedAvatar = null;
        this.chatConfigService.updateOverrides({ selectedModel: model, avatar: null });
    }
    /**
     * Handle avatar change
     */
    handleAvatarChange(avatar, chatElement) {
        this.chatStateService.selectedAvatar = avatar;
        this.chatStateService.selectedModel = null;
        this.chatConfigService.updateOverrides({ avatar, selectedModel: null });
        if (chatElement) {
            this.chatInteractionService.resetChat(chatElement, () => this.chatConfigService.getOverrides());
        }
    }
    /**
     * Handle conversation change
     */
    handleConversationChange(conversation, chatElement) {
        // Preserve current avatar selection when conversation changes
        const currentAvatar = this.chatStateService.selectedAvatar;
        console.log({ conversation });
        this.chatStateService.setConversationData(conversation);
        this.chatConfigService.updateOverrides({
            conversationId: conversation ? conversation.id : null,
            conversationTitle: conversation ? conversation.title : null,
            conversationUid: conversation ? conversation.uid : null,
        });
        // Always preserve avatar if it was set, regardless of conversation change
        if (currentAvatar) {
            this.chatConfigService.updateOverrides({ avatar: currentAvatar });
            // Ensure the selectedAvatar remains set
            if (!this.chatStateService.selectedAvatar) {
                this.chatStateService.selectedAvatar = currentAvatar;
            }
        }
        // this.chatStateService.injectedMessages = [];
        // if (!!conversation || conversation.id && chatElement) {
        //     this.chatInteractionService.clearChat(
        //         chatElement, 
        //         () => this.chatConfigService.getOverrides(),
        //         currentAvatar
        //     );           
        // }                
        if (chatElement) {
            console.log({ conversation, chatElement, currentAvatar });
            chatElement.requestUpdate();
        }
    }
    /**
     * Handle audio recording toggle
     */
    async handleAudioRecording(isRecording, onTranscriptionComplete) {
        const language = this.chatConfigService.chatConfigOverrides.language || 'en';
        await this.chatAudioService.toggleRecording(isRecording, language, onTranscriptionComplete);
        this.chatEventsService.handleAudioRecording(isRecording);
    }
    /**
     * Clear chat
     */
    clearChat(chatElement) {
        // Preserve current avatar before clearing
        const currentAvatar = this.chatStateService.selectedAvatar;
        if (chatElement) {
            this.chatInteractionService.clearChat(chatElement, () => this.chatConfigService.getOverrides(), currentAvatar);
            // Restore avatar after clearing
            if (currentAvatar) {
                this.chatStateService.selectedAvatar = currentAvatar;
                this.chatConfigService.updateOverrides({ avatar: currentAvatar });
            }
        }
    }
    /**
     * Reset chat
     */
    resetChat(chatElement) {
        if (chatElement) {
            this.chatInteractionService.resetChat(chatElement, () => this.chatConfigService.getOverrides());
        }
    }
    /**
     * Check if chat is visible
     */
    isChatVisible() {
        return this.chatStateService.isChatVisible() && !!this.chatConfigService.mainConfig;
    }
    /**
     * Append text to chat input
     */
    appendInputTextToChat(text, chatElement, send = false, hidden = false) {
        if (chatElement) {
            this.chatInteractionService.appendInputTextToChat(chatElement, text, send, hidden);
        }
    }
    /**
     * Sync conversation model to currently selected model
     */
    syncToConversationModel() {
        this.chatStateService.syncToConversationModel();
        this.chatEventsService.handleModelSync(this.chatStateService.conversation);
    }
    /**
     * Check if there's a model mismatch
     */
    hasModelMismatch() {
        return this.chatStateService.hasModelMismatch();
    }
    /**
     * Cleanup all services
     */
    cleanup() {
        this.chatEventsService.cleanup();
    }
};
exports.ChatServiceInstance = ChatService;
ChatService.VERBOSE = false;
exports.ChatServiceInstance = ChatService = ChatService_1 = __decorate([
    __param(0, ChatEventsService_1.default),
    __param(1, ChatConfigService_1.default),
    __param(2, ChatStateService_1.default),
    __param(3, ChatAudioService_1.default),
    __param(4, ChatInteractionService_1.default),
    __param(5, StorageService_1.default),
    __metadata("design:paramtypes", [typeof (_a = typeof ChatEventsService_1.ChatEventsServiceInstance !== "undefined" && ChatEventsService_1.ChatEventsServiceInstance) === "function" ? _a : Object, typeof (_b = typeof ChatConfigService_1.ChatConfigServiceInstance !== "undefined" && ChatConfigService_1.ChatConfigServiceInstance) === "function" ? _b : Object, typeof (_c = typeof ChatStateService_1.ChatStateServiceInstance !== "undefined" && ChatStateService_1.ChatStateServiceInstance) === "function" ? _c : Object, typeof (_d = typeof ChatAudioService_1.ChatAudioServiceInstance !== "undefined" && ChatAudioService_1.ChatAudioServiceInstance) === "function" ? _d : Object, typeof (_e = typeof ChatInteractionService_1.ChatInteractionServiceInstance !== "undefined" && ChatInteractionService_1.ChatInteractionServiceInstance) === "function" ? _e : Object, typeof (_f = typeof StorageService_1.StorageServiceInstance !== "undefined" && StorageService_1.StorageServiceInstance) === "function" ? _f : Object])
], ChatService);
exports.default = ChatService.getSingleton();
